import styled from 'styled-components/macro'
import { Button } from '@scuf/common'

export const DeleteButton = styled(Button)`
  margin: auto;
`
